import apiClient from '@/api/apiClient.js';
import { getPatPatientsId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    catEventType: [],
    events: [],
    status: '',
    dataNameProfes: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    catEventType(state) {
      return state.catEventType;
    },
    status(state) {
      return state.status;
    },
    dataNameProfes(state) {
      return state.dataNameProfes;
    },
    events(state) {
      return state.events;
    },
  },

  mutations: {
    insertSchema(state, payload) {
      state.schema = payload?.schema;
      state.catEventType = Array.isArray(payload?.catEventType)
        ? payload.catEventType
        : [];
    },
    insertEvents(state, events) {
      state.events = events;
    },
    pinSuccess(state, dataPro) {
      state.status = dataPro.pinMatch;
      state.dataNameProfes = dataPro.dataNameProfes;
    },
    pinError(state) {
      state.status = false;
    },
    saveSuccess(state, saveEvents) {
      state.status = saveEvents;
    },
    saveError(state) {
      state.status = 'error';
    },
    delSuccess(state, delEvent) {
      state.status = delEvent;
    },
    delError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.patAppointmentsASchema();
        const schema = res.data;

        const res2 = await apiClient.catEventType();
        const catEventType = res2.data.data;
        commit('insertSchema', {schema, catEventType});
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadEvents({ commit }) {
      try {
        const id = getPatPatientsId();

        const res = await apiClient.modelPatAppointmentsA(id);
        const events = res.data.data;

        commit('insertEvents', events);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async verifPro({ commit }, payload) {
      try {
        const id = getPatPatientsId();
        let model = payload.model;

        const res = await apiClient.createPatAppointmentsA(id, model);
        const pinMatch = res.data.data.pinMatch;

        let dataNameProfes;
        if (pinMatch === true) {
          dataNameProfes = res.data.data.nameProfes;
        }

        let dataPro = { pinMatch, dataNameProfes };
        commit('pinSuccess', dataPro);
      } catch (e) {
        console.error(e);
        commit('pinError');
      }
    },
    async saveEvents({ commit }, payload) {
      try {
        const id = getPatPatientsId();

        let model = payload.model;
        model.patientId = getPatPatientsId();

        const res = await apiClient.createPatAppointmentsA(id, model);
        const events = res.data.data;

        let saveEvents;
        if (events) {
          saveEvents = true;
        } else {
          saveEvents = false;
        }

        commit('saveSuccess', saveEvents);
      } catch (e) {
        console.error(e);
        commit('saveError');
      }
    },
    async updateEvents({ commit }, payload) {
      try {
        const id = payload.id;
        const model = payload.model;
        const res = await apiClient.updatePatAppointmentsA(id, model);

        let delEvent;
        res.status === 204 ? (delEvent = true) : (delEvent = false);
        commit('delSuccess', delEvent);
      } catch (e) {
        console.error(e);
        commit('delError');
      }
    },
    async delEvents({ commit }, payload) {
      try {
        const id = payload.id;
        const res = await apiClient.deletePatAppointmentsA(id);

        let delEvent;
        res.status === 204 ? (delEvent = true) : (delEvent = false);
        commit('delSuccess', delEvent);
      } catch (e) {
        console.error(e);
        commit('delError');
      }
    },
  },
};
